import { BiApiClientBase, BiApiClientContext } from "./BiApiClientProviderContext";

export const BiApiClientProvider = <T extends BiApiClientBase>({
  api,
  children,
}: {
  api: T;
  children: React.ReactNode;
}) => <BiApiClientContext.Provider value={api}>{children}</BiApiClientContext.Provider>;
